const CHECKOUT_STATE_API_TIMEOUT = 30000;
const CHECKOUT_PAGES = ['cart', 'preview', 'finish', 'login-selection'];
const CHECKOUT_STATE_URL = `/semiprotected/api/checkout/state-api`;
const REQUEST_METHOD = {
    POST: 'POST',
    PUT: 'PUT',
    PATCH: 'PATCH',
    DELETE: 'DELETE',
};
const API = {
    GET_CART_VERSION: '/cart-version',
    GET: '/get',
    SET_SAVING_PLAN_ARTICLE: '/set-saving-plan-article',
    SET_SHIPPING_COUNTRY: '/change-shipping-country',
    SET_COUPON: '/add-coupon',
    DELETE_COUPON: '/remove-coupon',
    SET_SAMPLE_ARTICLE: '/set-free-sample-article',
    SET_ARTICLE_QUANTITY: '/set-article-quantity',
    SET_SUBSCRIPTION_INTERVAL: '/set-cart-subscription-details',
    REMOVE_SUBSCRIPTION: '/convert-cart-to-single-delivery',
    CREATE_BASIC_GUEST_ACCOUNT: '/customer/basic-guest-customer',
    UPADTE_GUEST_ACCOUNT_EMAIL: '/customer/basic-guest-customer/email',
    SET_ADDRESSES: '/customer/addresses',
    DELETE_SAVED_CARD: '/payment/card/{pspIdentifier}?psp={psp}',
    DELETE_SAVED_BANCONTACT: '/payment/bancontact/{bancontactIdentifier}',
    UPDATE_PREFERRED_PAYMENT: '/payment/method/preferred',
    SET_DELIVERY_SERVICE: '/delivery/service',
};
const TOGGLE_EXPERIMENT = {
    CHECKOUT_FRONTEND_NEW_OVERVIEW_PAGE: 'sc-4147_checkout_frontend_new_overview_page',
    CHECKOUT_FRONTEND_NEW_PREVIEW_PAGE: 'sc-4336_checkout_frontend_new_preview_page',
    CHECKOUT_OB_SAMPLES_INTEGRATION_FEATURE_ENABLED: 'sc-4641_checkout_ob_samples_integration_feature',
    CHECKOUT_OMNIBUS_DIRECTIVE_FEATURE: 'sc-4861_checkout_omnibus_directive_feature',
    NEW_PRICING_COMPONENT_IN_CART_AND_PREVIEW: 'sc-5417_new_pricing_component_in_cart_and_preview',
    HIDE_AUTOSHIPMENT_COMPONENT: 'sc-5939_hide_autoshipment_offer_box_on_cart_page',
};
const DEFAULT_LOCALE = 'de-DE';
const DEFAULT_DOMAIN = 'zooplus.de';
const DEFAULT_CURRENCY = 'EUR';
const DEFAULT_SITE_ID = 1;
const REALM = {
    ZOOPLUS: 'zooplus',
    BITIBA: 'bitiba',
};
const MUTATION = {
    SET_ARTICLE_QUANTITY: 'SetArticleQuantity',
    SET_SAVINGS_PLAN_ARTICLE: 'SetSavingsPlanArticle',
    SET_COUPON: 'SetCoupon',
    DELETE_COUPON: 'DeleteCoupon',
    SET_FREE_SAMPLE_ARTICLE: 'SetFreeSampleArticle',
    SET_SHIPPING_COUNTRY: 'SetShippingCountry',
    SET_SUBSCRIPTION_INTERVAL: 'SetSubscriptionInterval',
    REMOVE_SUBSCRIPTION: 'RemoveSubscription',
    CREATE_BASIC_GUEST_ACCOUNT: 'CreateBasicGuestAccount',
    UPADTE_GUEST_ACCOUNT_EMAIL: 'UpdateGuestAccountEmail',
    SET_ADDRESSES: 'SetAddresses',
    DELETE_SAVED_CARD: 'DeleteSavedCard',
    DELETE_SAVED_BANCONTACT: 'DeleteSavedBancontact',
    UPDATE_PREFERRED_PAYMENT: 'UpdatePreferredPayment',
    SET_DELIVERY_SERVICE: 'SetDeliveryService',
};
const PROJECT_ID = {
    CHECKOUT_FRONTEND: 'checkout-frontend',
    RECOMMENDATION: 'recommendations-component',
    SAMPLES: 'samples-component',
    AUTOSHIPMENT: 'autoshipment-component',
    DELIVERY_AND_INVOICE_ADDRESSES: 'delivery-and-invoice-addresses',
    PAYMENT_FRONTEND: 'payment-frontend',
    DELIVERY_SERVICES: 'delivery-services',
    SAVINGS_PLAN: 'savings-plan-offer-box-component',
};
const PROJECT_IDS_LIST = Object.values(PROJECT_ID);

export { API, CHECKOUT_PAGES, CHECKOUT_STATE_API_TIMEOUT, CHECKOUT_STATE_URL, DEFAULT_CURRENCY, DEFAULT_DOMAIN, DEFAULT_LOCALE, DEFAULT_SITE_ID, MUTATION, PROJECT_ID, PROJECT_IDS_LIST, REALM, REQUEST_METHOD, TOGGLE_EXPERIMENT };
//# sourceMappingURL=config.js.map
